<template>
    <div>
        <b-row v-if="products.length">
            <b-col cols="12" md="3" v-for="(product,index) in products" :key="index">
                <b-card>
                    <img :src="product.product_image_url" alt="image" height="85"
                         class="img-fluid mb-3">

                    <p @click="getUrlProduct(product.product_id)" v-html="product.product_title"></p>
                    <ul class="list-group">
                        <li v-if="product.pivot.type_price === 'gram' || product.pivot.type_price === 'gram_offer'"
                            class="list-group-item d-flex justify-content-between align-items-center font-weight-bolder">
                            {{product.pivot.amount_gram}}g
                        </li>
                        <li class="list-group-item d-flex justify-content-between align-items-center">
                            {{$t('Count')}}
                            <span class="badge badge-light badge-pill">
                                                                        {{product.pivot.count}}
                                                                    </span>
                        </li>
                        <li v-if="product.pivot.type_price === 'gram' || product.pivot.type_price === 'gram_offer'"
                            class="list-group-item d-flex justify-content-between align-items-center">
                            title
                            <span class="badge badge-light badge-pill">
                                                                        {{product.pivot.amount_title}}
                                                                    </span>
                        </li>
                        <li class="list-group-item d-flex justify-content-between align-items-center">
                            price
                            <span v-if="product.pivot.type_price === 'single_price_offer' || product.pivot.type_price === 'gram_offer'"
                                  class="badge badge-light badge-pill">
                                                                        <span class="mr-3"
                                                                              style="text-decoration: line-through">{{product.pivot.total_price_without_sell_item * product.pivot.count}} €</span>
                                                                        <span class="text-danger">{{product.pivot.total_price_sell_item * product.pivot.count}} €</span>
                                                </span>
                            <span v-else class="badge badge-light badge-pill">
                                                    <span>{{product.pivot.total_price_item * product.pivot.count}} €</span>
                                                </span>
                        </li>
                    </ul>
                    <div class="border-top mt-3" v-if="product.product_is_package === 'yes'">
                        <template v-if="product.pivot.package_items !== null">
                                            <span style="white-space: inherit;line-height: 16px"
                                                  class="badge badge-light badge-pill mt-2"
                                                  :key="index"
                                                  v-for="(item,index) in stringToArray(product.pivot.package_items)">
                                                    <span>{{item}}</span>
                                                </span>
                        </template>

                    </div>
                </b-card>
            </b-col>
        </b-row>
    </div>
</template>

<script>
    import Http from '../../../Services/HttpService/HttpService'
    import Notification from '../../../Services/Notification/Nottification'


    export default {
        name: "orderProducts",
        props: {
            products: {
                type: Array,
                default: null
            }
        },
        methods:{
            stringToArray(value) {
                return value.split(',')
            },
            getUrlProduct(id){
                Http.get(Http.apiurlV2() + 'order/get/url/product/' + id)
                    .then(response => {
                        this.$Progress.finish();
                        if (response.data.status_code === Http.ok()) {
                            window.open(response.data.data.url, '_blank');
                        } else {
                            Notification.error(response.data.message)
                        }
                    })
                    .catch(error => {
                        this.$Progress.finish();
                    })
            }
        }
    }
</script>

<style scoped>

</style>